import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function EditEmployee() {
  const { id } = useParams();
  const [form, setForm] = useState(null);

  useEffect(() => {
    // Dummy fetch (replace with API later)
    const data = {
      1: { name: "John Doe", email: "john@example.com", department: "Sales", designation: "Executive" },
      2: { name: "Jane Smith", email: "jane@example.com", department: "HR", designation: "Manager" },
      3: { name: "Robert Brown", email: "robert@example.com", department: "IT", designation: "Engineer" },
    };

    setForm(data[id]);
  }, [id]);

  if (!form) return <p>Loading...</p>;

  const update = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = () => alert("Employee Updated Successfully!");

  return (
    <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-6">
      <h1 className="text-2xl font-bold text-blue-700 mb-4">Edit Employee</h1>

      <div className="grid grid-cols-2 gap-4">
        <input name="name" value={form.name} className="input" onChange={update} />
        <input name="email" value={form.email} className="input" onChange={update} />

        <input name="department" value={form.department} className="input" onChange={update} />
        <input name="designation" value={form.designation} className="input" onChange={update} />
      </div>

      <button
        className="mt-6 w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 font-semibold"
        onClick={submit}
      >
        Save Changes
      </button>
    </div>
  );
}
